import Decision from 'slotworks/state-machine/decisions/decision';
import { Exit } from 'slotworks/state-machine/data/exit';
import gameState from 'slotworks/model/game-state';
import BuyoutResult from 'integration/buyout-result';
import { BuyoutTypes } from 'components/bonus-buy/bonus-buy-prompt';

export default class IsBuyFreeSpinsCheck extends Decision {
    public evaluate() {
        const record = gameState.getCurrentGame().getCurrentRecord();

        if (record) {
            const result = record.getResultsOfType(BuyoutResult) as BuyoutResult[];
            if (result && result.length > 0 && result[0].type == BuyoutTypes.BUYOUT_SPINS) {
                return Exit.True;
            }
        }

        return Exit.False;
    }
}



// WEBPACK FOOTER //
// ./src/desicions/is-buy-freespins-check.ts